module.exports = __webpack_public_path__ + "img/CANAM.cce7cdb.jpg";